export function isValidPassport(value) {
  const regex = new RegExp(/^[0-9a-zA-Z]{6,9}$/)

  const match = regex.exec(value)

  if (!match) return false

  return true
}
